import { render, staticRenderFns } from "./baseInfoCopy.vue?vue&type=template&id=9cb80930&scoped=true"
import script from "./baseInfoCopy.vue?vue&type=script&lang=js"
export * from "./baseInfoCopy.vue?vue&type=script&lang=js"
import style0 from "./baseInfoCopy.vue?vue&type=style&index=0&id=9cb80930&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb80930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cb80930')) {
      api.createRecord('9cb80930', component.options)
    } else {
      api.reload('9cb80930', component.options)
    }
    module.hot.accept("./baseInfoCopy.vue?vue&type=template&id=9cb80930&scoped=true", function () {
      api.rerender('9cb80930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/baseInfoCopy.vue"
export default component.exports